import React, { Component } from 'react';
import { message } from 'antd';
import services from '../../services/api';
import Modal from '../../components/Modal/index';

export default class CommonListsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listsData: []
    };
    this.api = '';
    this.addComponent = '';
    this.editComponent = '';
    this.listsComponent = '';
    this.model_width = undefined;
  }

  queryList(params) {
    services[this.api].query(params).then(data => {
      if (data.code === 0) {
        this.setState({
          listsData: data.data
        });
      } else {
        message.error(data.msg);
      }
    });
  }

  add = () => {
    const AddComponent = this.addComponent;
    if (typeof AddComponent === 'string') {
      this.props.history.push(AddComponent);
    } else if (AddComponent instanceof Object) {
      Modal.open({
        title: '新增',
        width: this.model_width ? this.model_width : '1000px',
        content: (
          <AddComponent
            closeModal={this.closeModal}
            actionType="add"
            {...this.props}
          />
        ),
        isOkBtn: false,
        isCancelBtn: false
      });
    } else {
      console.log('something error');
    }
  };

  replaceUrlForId = (url, id) => {
    return url.replace(`/id/`, `/${id}/`);
  };

  edit = record => {
    const EditComponent = this.editComponent;
    if (typeof EditComponent === 'string') {
      this.props.history.push(this.replaceUrlForId(EditComponent, record.id));
    } else if (EditComponent instanceof Object) {
      Modal.open({
        title: '编辑',
        width: this.model_width ? this.model_width : '1000px',
        content: (
          <EditComponent
            record={record}
            closeModal={this.closeModal}
            actionType="update"
            {...this.props}
          />
        ),
        isOkBtn: false,
        isCancelBtn: false
      });
    } else {
      console.log('something error');
    }
  };

  closeModal = params => {
    Modal.close();
    this.queryList(params);
  };
}
